<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="department.departmentID > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="department"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="编号">
              <el-input v-model="department.departmentNO" disabled placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="外部编号">
              <el-input v-model="department.outerNO" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="名称" prop="departmentName">
              <el-input v-model="department.departmentName" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话">
              <el-input v-model="department.telephone" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="部门主管" prop="directorName">
              <div style="display: flex;flex-direction: row;">
                <el-input v-model="department.directorName" placeholder="请输入" readonly>
                  <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectEmployee.open()">选择主管</el-button>
                </el-input>
                <employee-select ref="selectEmployee" @select="selectEmployee"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上级部门" prop="parentName">
              <div style="display: flex;flex-direction: row;">
                <el-input v-model="department.parentName" placeholder="请输入" readonly>
                  <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectDepartment.open()">选择部门</el-button>
                </el-input>
                <department-select ref="selectDepartment" @select="selectDepartment"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="传真">
              <el-input v-model="department.fax" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input v-model="department.note" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import regular from "@/util/regular";
  export default {
    name:"DepartmentEdit",
    components: {EmployeeSelect, DepartmentSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        department: {
          departmentID: "",
          departmentNO: "",
          departmentName: "",
          outerNO: "",
          directorID: "",
          directorName: "",//部门主管
          employeeName: "",
          telephone: "",
          fax: "",
          parentID: "",
          parentName: "",//上级部门
          note: "",
          isDeleted: "",
        },
        ruleValidate: {
          departmentName: {required: true, message: "不能为空",trigger: "blur"},
          telephone:
            {
              required: true,
              pattern: regular.phone,
              message: "手机号格式不对",
              trigger: "blur",
            },
          directorName: {required: true, message: "不能为空",trigger: "blur"},
          parentName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.department.departmentID = id;
        console.log(id);
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }else {
          this.getNode();
        }
      },
      selectEmployee(row) {
        console.log(row);
        this.department.directorID = row.employeeID;
        this.department.employeeName = row.employeeName;
        this.department.directorName = row.employeeName;
      },
      selectDepartment(row) {
        this.department.parentID = row.departmentID;
        this.department.parentName = row.departmentName;
      },
      getData() {
        this.$http
          .get("basic", `departments/${this.department.departmentID}`)
          .then(resp => {
            console.log(resp);
            this.department = resp;
          });
      },
      getNode() {
        this.$http
          .get("basic", "departments/selectDepartmentNo")
          .then(resp => {
            console.log(resp);
            this.department.departmentNO = resp;
          });
      },
      handleSubmit() {
        if(this.department.departmentID>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "departments",  this.department)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "departments", this.department)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
